import axios from 'axios';
import { normalizeGetTableQuery } from "@/utils/globalHelpers";

export class AppSettingService {
  async getSettings() {
    return await axios.get('/api/v1/portal/app-setting');
  }

  async getPublicSettings() {
    return await axios.get('/api/v1/site-settings');
  }
  async updateSettings(payload) {
    return await axios.post('/api/v1/portal/app-setting', payload);
  }
  async getUpdatePriceHistory(params) {
    return await axios.get('/api/v1/portal/update-price-history', { params: normalizeGetTableQuery(params) });
  }
}
